import { graphql } from '@api/mesa'

const GET_MORTGAGE_ADDRESSES = graphql(`
  query GetMortgageAddresses {
    getMortgageAddresses {
      addresses {
        id
        address1
        address2
        city
        state
        zip
        country
        plaidAccount {
          plaidAccountId
          accountName
          bankAccountLast4
          bankName
        }
      }
    }
  }
`)

const GET_MORTGAGE_REDEMPTION_METRICS = graphql(`
  query GetMortgageRedemptionMetrics {
    getCashForMortgageRedemptionMetrics {
      totalPointsRedeemed
      totalAmountCents
      isEligible
      remainingMonthlyCents
    }
  }
`)

export const PointsToCashForMortgageGqlQueries = {
  GET_MORTGAGE_ADDRESSES,
  GET_MORTGAGE_REDEMPTION_METRICS,
}
